<template>
    <top-bar :page="'roster'" :leftText="'Cast'" />
    <div class="container-fluid">
        <div class="row" v-if="characters.length > 0">
            <div
                class="col-sm-3 mb-2"
                v-for="(character, index) in characters"
                :key="index"
            >
                <character-box :character="character" />
            </div>
        </div>
        <div v-else class="no-data-message vh-100 d-flex align-items-center justify-content-center" role="alert">
            <h2>No characters in roster. Please use New Character to create one!</h2>
        </div>
    </div>
    <div class="version">V1.4.6</div>
</template>

<script>
import CharacterBox from "./CharacterBox.vue";
import { computed } from "vue";
import { useRosterStore } from "../stores/index";
import TopBar from "./TopBar.vue";

export default {
    setup() {
        const store = useRosterStore();
        const characters = computed(() => store.characters);

        return {
            characters,
        };
    },
    components: {
        CharacterBox,
        TopBar,
    },
};
</script>

<style>
.version {
    position: fixed;
    bottom: 10px;
    right: 10px;
    color: #666;
    font-size: 0.9rem;
}
</style>

